import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProformViewStates } from '../../../dtos/proforms.dto';
import { ProformsAdminService } from '../../../services/proforms/proforms-admin.service';
import { ProFormsAPIResponse } from '../../../types/responses/proforms.responses';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-proform-live-preview-modal',
  standalone: false,
  templateUrl: './proform-live-preview-modal.component.html',
  styleUrl: './proform-live-preview-modal.component.scss',
})
export class ProformLivePreviewModalComponent implements OnInit, OnDestroy {
  @ViewChild('modal') modal: ModalComponent;

  viewStates = ProformViewStates;

  form: ProFormsAPIResponse | null = null;

  private sub: Subscription;

  constructor(private proformsAdminService: ProformsAdminService) {}

  ngOnInit() {
    this.sub = this.proformsAdminService.currentProForm.subscribe((form) => {
      // Spread to create a new reference so Angular's ngOnChanges detects the update
      this.form = form ? { ...form } : null;
    });
  }

  openModal() {
    this.modal.open();
  }

  closeModal() {
    this.modal.close();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
